import { render, staticRenderFns } from "./LottieIcon.vue?vue&type=template&id=e836f700"
import script from "./LottieIcon.vue?vue&type=script&lang=js"
export * from "./LottieIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports